/**
 * SubscriptionDiscountCampaignErrorModalCtrl controller
 *
 * @class SubscriptionDiscountCampaignErrorModalCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:SubscriptionDiscountCampaignErrorModalCtr
 */

/* @ngInject */
export default function SubscriptionDiscountCampaignErrorModalCtrl ($uibModalInstance, autoPayError, freeError, periodTypeError, deleteError, dc, subscription) {
  const vm = this
  vm.autoPayError = autoPayError
  vm.freeError = freeError
  vm.periodTypeError = periodTypeError
  vm.deleteError = deleteError
  vm.dc = dc

  vm.subscription = subscription

  vm.mapDCNames = function () {
    return vm.dc.map((c) => c.name).join(', ')
  }
  vm.displayJoiner = function (index, length) {
    return index < length - 1 ? ', ' : ''
  }

  vm.dismiss = $uibModalInstance.dismiss

  vm.close = $uibModalInstance.close
}
